import { render, staticRenderFns } from "./createObservation.vue?vue&type=template&id=15b4bbaa&scoped=true&"
import script from "./createObservation.vue?vue&type=script&lang=js&"
export * from "./createObservation.vue?vue&type=script&lang=js&"
import style0 from "./createObservation.vue?vue&type=style&index=0&id=15b4bbaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4bbaa",
  null
  
)

export default component.exports